
import { Component, Vue, Prop } from 'vue-property-decorator';
import { BaseText, LoaderIndicator } from '@warrenbrasil/nebraska-web';
import {
  Accordion,
  AccordionWrapper
} from '@/modules/common/components/Accordion';
import { getString } from '@/modules/common/helpers/resources';
import { getFaq, IFaq } from '@/modules/help-center/services/faq';
import { dateViewer as date } from '@/modules/common/helpers/date';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    BaseText,
    LoaderIndicator,
    AccordionWrapper,
    Accordion
  },
  filters: { date }
})
export default class FAQ extends Vue {
  @Prop({ type: String })
  public subject!: string;

  private getString = getString;
  private faqData: IFaq | any = {};
  private isLoading = true;

  get NebraskaColors() {
    return NebraskaColors;
  }

  private async beforeMount() {
    this.faqData = await this.getFaqQuestions();
    this.isLoading = false;
  }

  private async getFaqQuestions() {
    return getFaq(this.subject);
  }
}
